

const sleep = msec =>
  new Promise(resolve => setTimeout(resolve, msec))


const searchBottomAddCartElement = async () => {
  for (let i = 0; i < 40; i++) {
      const bottomAddCartElement = document.querySelector('div.bottom-form')
      if (bottomAddCartElement) {
          return bottomAddCartElement
      }
      await sleep(200)
  }
  return null
}

let bottomAddCartElement
searchBottomAddCartElement().then(element => {
  if (element) {
    bottomAddCartElement = element
  }
})


const searchGiftOptionElement = async () => {
   for (let i = 0; i < 40; i++) {
      const giftOptionElement = document.querySelectorAll('.anygift-option-button__circle')[1]
      if (giftOptionElement) {
          return giftOptionElement
      }
      await sleep(200)
  }
  return null
}


searchGiftOptionElement().then((giftOptionElement) => {
  if (giftOptionElement) {
    const giftOptionObserver = new MutationObserver((mutations) => {
      mutations.forEach((value) => {
        const isGiftSelected = Array.from(value.target.classList).includes('anygift-option-button__circle-active')

        if (isGiftSelected) {
          bottomAddCartElement.remove()
        }
      });
    });

    const observerConfig = {
      childList: false,
      attributes: true,
      characterData: false,
      subtree: false,
    };

    giftOptionObserver.observe(giftOptionElement, observerConfig)
  }
})